(ns ncr.fragment.props.estimates
  (:require
   [tick.core :as t]
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [uix.core.alpha :as uix]
   [com.rpl.specter :as sp]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.fragment.props.estimates-dialog :as ed]
   [ncr.widgets.core :as w]
   [ncr.me :as me]))

(defn- transform-in [m]
  (->> (or m [])
    (sp/setval [sp/ALL :title nil?] "Flow")
    (sp/setval [sp/ALL :intervals sp/ALL :about nil?] "Interval")
    (sp/transform [sp/ALL :intervals sp/ALL :direction] name)
    (sp/transform [sp/ALL :intervals sp/ALL :per] name)
    (sp/transform [sp/ALL :intervals sp/ALL :labels] first)
    (sp/setval [sp/ALL :intervals sp/ALL (sp/map-key :labels) sp/NAME] :label)))

(defn- transform-out [m]
  (letfn
    [(date [d]
       (when d
         (t/date d)))]

    (some->> m
      (sp/transform [sp/ALL :intervals sp/ALL :direction] keyword)
      (sp/transform [sp/ALL :intervals sp/ALL :per] keyword)
      (sp/transform [sp/ALL :intervals sp/ALL :label] hash-set)

      (sp/transform [sp/ALL :intervals sp/ALL :start-date] date)
      (sp/transform [sp/ALL :intervals sp/ALL :end-date] date)

      (sp/setval [sp/ALL (sp/if-path [:intervals (sp/pred empty?)] [])] sp/NONE)
      (sp/setval [sp/ALL :intervals sp/ALL (sp/map-key :label) sp/NAME] :labels)
      (sp/setval [sp/ALL :intervals sp/ALL (sp/if-path [:per (sp/pred= :period)] [:step])] sp/NONE)
      (sp/setval [sp/ALL :intervals sp/ALL :violations] sp/NONE)
      (seq)
      (vec))))

(defn- validate [m]
  (letfn
    [(validate [interval]
       (->>
         [(when (or (nil? (:brutto interval)) (nil? (:netto interval))) :netto-brutto)
          (when (nil? (:start-date interval)) :start-date)
          (when (nil? (:label interval)) :label)]

         (filter some?)
         (into #{})
         (assoc interval :violations)))]
    (sp/transform [sp/ALL :intervals sp/ALL] validate m)))

(defn c-edit-dialog [{:keys [initial save! title labels]}]
  [ed/c-edit-dialog
   (let
     [flows (uix/state (validate (transform-in initial)))
      undo (uix/state '())]
     {:title title

      :labels
      labels

      :flows
      @flows

      :operations
      (letfn
        [(edit! [& args]
           (swap! flows
             (fn [old]
               (let [new (validate (apply (first args) old (rest args)))]
                 (when (not= new old)
                   (swap! undo conj old))
                 new))))

         (dissocv [ix v]
           (into (subvec v 0 ix) (subvec v (inc ix))))]

        {:merge-in
         (fn
           ([flow-ix patch]
            (edit! update-in [flow-ix] merge patch))
           ([flow-ix interval-ix patch]
            (edit! update-in [flow-ix :intervals interval-ix] merge patch)))

         :flow-add
         (fn []
           (edit!
             (fn [flows]
               (conj flows {:title (str "Flow " (inc (count flows))) :intervals []}))))

         :flow-delete
         (fn [flow-ix]
           (edit!
             (fn [flows]
               (dissocv flow-ix flows))))

         :interval-add
         (fn [flow-ix]
           (edit!
             (fn [flows]
               (update-in flows [flow-ix :intervals]
                 (fn [intervals]
                   (conj intervals
                     {:about (str "Interval " (inc (count intervals)))
                      :direction "income"
                      :per "month"}))))))

         :interval-delete
         (fn [flow-ix interval-ix]
           (edit!
             (fn [flows]
               (update-in flows [flow-ix :intervals]
                 (fn [intervals]
                   (dissocv interval-ix intervals))))))

         :undo
         (when (seq @undo)
           (fn []
             (reset! flows (first @undo))
             (swap! undo rest)))})

      :save!
      (fn [message]
        (go
          (let [estimates (transform-out @flows)]
            (<! (save! estimates message)))))

      :validated
      (not
        (sp/selected-any? [sp/ALL :intervals sp/ALL :violations seq] @flows))})])

;; ?????
(defn- estimates-title-tmp [{:keys [estimates _wrap?]}]
  (let [flows (count estimates)
        spans (->> estimates (map (comp count :intervals)) (apply +))]
    (str "flows: " flows ", spans: " spans)))

(defn c-estimate-property [props initial save!]
  (let
    [label (get props :label "")
     me (uix/context me/*context*)]
    [pf/c-form-group {:class :ncr-c-drawer-panel-properties__estimate :label label}
     [pf/c-input-group
      [pf/c-button
       {:class (when initial :pf-u-w-100)
        :variant :secondary
        :on-click
        #(go
           (when-let
             [_
              (async/<!
                (m/!modal #'c-edit-dialog
                  {:title label
                   :initial initial
                   :save! save!
                   :labels
                   (get-in me [:cluster :labels])}))]))}
       (if initial
         [estimates-title-tmp {:estimates initial :wrap? true}]
         [w/c-mdi-icon {:icon :plus}])]
      (when initial
        [pf/c-tooltip {:content [:span "Remove estimates"] :position :auto :enable-flip true}
         [pf/c-button {:variant "plain" :class :ncr-c-drawer-panel-properties__estimate-reset}
          [w/c-mdi-icon {:icon :delete-outline :on-click #(save! nil "Estimate: [removed]")}]]])]]))

(defn c-estimate-label [value]
  [:<>
   [w/c-mdi-icon {:icon :chart-gantt :class :pf-u-pr-xs}]
   (estimates-title-tmp {:estimates value})])
